import { ButtonDropdown as ButtonDropdownComponent } from '@idaho-aeyc/ui-kit';
import { ButtonDropdownProps } from './ButtonDropdown.types';

export const ButtonDropdown = ({ ...props }: ButtonDropdownProps) => {
  return <ButtonDropdownComponent {...props} />;
};
